import React from "react";
import LegalLayout from "../components/LegalLayout";

const Impressum: React.FC = () => (
  <LegalLayout title="Impressum">
    <section>
      <h2>Angaben gemäß § 5 DDG</h2>
      <p>
        <strong>AVILA Projektmanagement GmbH</strong>
        <br />
        Grunewaldstraße 24
        <br />
        12165 Berlin
      </p>
    </section>

    <section>
      <h2>Kontakt</h2>
      <p>
        Telefon: +49&nbsp;30&nbsp;374&nbsp;363&nbsp;70
        <br />
        Fax: +49&nbsp;30&nbsp;805&nbsp;819&nbsp;28
        <br />
        E-Mail: <a href="mailto:info@avila-projektmanagement.de">info@avila-projektmanagement.de</a>
        <br />
        Web:{" "}
        <a
          href="https://www.avila-projektmanagement.de"
          target="_blank"
          rel="noopener noreferrer"
        >
          www.avila-projektmanagement.de
        </a>
      </p>
    </section>

    <section>
      <h2>Vertreten durch</h2>
      <p>Geschäftsführer: Dr. Douglas Fernando</p>
    </section>

    <section>
      <h2>Registereintrag</h2>
      <p>
        Eingetragen im Handelsregister beim Amtsgericht Charlottenburg
        <br />
        Registernummer: HRB&nbsp;100178&nbsp;B
      </p>
    </section>

    <section>
      <h2>Umsatzsteuer-ID</h2>
      <p>
        Umsatzsteuer-Identifikationsnummer gemäß §&nbsp;27&nbsp;a UStG:
        <br />
        DE814932468
      </p>
    </section>

    <section>
      <h2>Gewerbeerlaubnis</h2>
      <p>
        Die AVILA Projektmanagement GmbH besitzt die Erlaubnis nach §&nbsp;34c&nbsp;GewO.
       Zuständige Aufsichtsbehörde gemäß § 34c GewO: Bezirksamt Steglitz-Zehlendorf von Berlin, Unter den Eichen 1, 12203 Berlin.
      </p>
    </section>

    <section>
      <h2>Inhaltlich verantwortlich für den Inhalt nach § 18 Abs. 2 Medienstaatsvertrag (MStV)</h2>
      <p>
        Dr. Douglas Fernando.
      </p>
    </section>

    <section>
      <h2>Haftungsausschluss</h2>
      <p>
        Diese Website stellt den aktuellen Stand eines kontinuierlichen Arbeitsprozesses dar.
        Trotz sorgfältiger Prüfung können wir keine Gewähr für die Vollständigkeit, Richtigkeit
        und Aktualität der Inhalte übernehmen.
      </p>
      <p>
        Haftungsansprüche gegen die AVILA Projektmanagement GmbH, die sich auf Schäden
        materieller oder ideeller Art beziehen, die durch die Nutzung oder Nichtnutzung der
        angebotenen Informationen bzw. durch fehlerhafte oder unvollständige Informationen
        verursacht wurden, sind ausgeschlossen, sofern kein nachweislich vorsätzliches oder grob
        fahrlässiges Verschulden vorliegt. Änderungen oder Ergänzungen der Inhalte behalten wir
        uns jederzeit ohne vorherige Ankündigung vor.
      </p>
    </section>

    <section>
      <h2>Links zu externen Websites</h2>
      <p>
        Unsere Website enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen
        Einfluss haben. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter
        oder Betreiber verantwortlich. Bei Bekanntwerden von Rechtsverletzungen werden wir
        derartige Links umgehend entfernen.
      </p>
    </section>

    <section>
      <h2>Urheberrecht</h2>
      <p>
        Die durch die AVILA Projektmanagement GmbH erstellten Inhalte und Werke auf dieser Website
        unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und
        jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen
        Zustimmung der AVILA Projektmanagement GmbH.
      </p>
    </section>

    <section>
      <h2>Verbraucherstreitbeilegung</h2>
      <p>
       Wir nehmen an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle nicht teil und sind dazu auch nicht verpflichtet.
      </p>
    </section>

    <section>
      <h2>Verwendete Open-Source-Komponenten</h2>
      <p>
        Diese Website verwendet Symbole von{" "}
        <a href="https://lucide.dev/" target="_blank" rel="noopener noreferrer">
          Lucide Icons
        </a>{" "}
        unter der{" "}
        <a
          href="https://github.com/lucide-icons/lucide/blob/main/LICENSE"
          target="_blank"
          rel="noopener noreferrer"
        >
          ISC-Lizenz
        </a>
        .<br />
        Copyright © 2013–2023 Cole Bemis (Feather Icons) und © 2025 Lucide Contributors.
      </p>
      <p>
        Die Verwendung erfolgt gemäß den Bedingungen der ISC-Lizenz. Eine kommerzielle Nutzung ist
        erlaubt, sofern der obige Urheberrechtshinweis und die Lizenzbedingungen in allen Kopien
        enthalten sind.
      </p>
    </section>
  </LegalLayout>
);

export default Impressum;
